const isJSON = function (arg) {
  console.debug('*** Start *** isJSON')
  arg = typeof arg === 'function' ? arg() : arg
  if (typeof arg !== 'string') {
    console.debug('is not JSON')
    return false
  }
  try {
    arg = !JSON ? '(' + arg + ')' : JSON.parse(arg)
    console.debug('is JSON')
    return true
  } catch (e) {
    console.debug('is not JSON')
    return false
  }
}

export default isJSON



// WEBPACK FOOTER //
// ./src/functions/isJSON.js